var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cameras !== undefined)?_c('camera-viewer',{attrs:{"cameras":_vm.cameras}}):_vm._e(),(_vm.plots !== undefined)?_c('plot-viewer',{attrs:{"plots":_vm.plots}}):_vm._e(),_c('site-map',{attrs:{"devices":_vm.devices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }